module.exports = __webpack_public_path__ + "static/media/logo-st-joseph.c81da557.svg";